module.exports = __webpack_public_path__ + "static/customer-service-3dde8226b69fc8860189e6fbb7f2d986.svg";